namespace $ {

	export type $shm_hitalama_map_history_text_file = {
		hitalama_text_file: string
		size: number
		preview: string
	}

	export function $shm_hitalama_map_history_text_file_is(
		value: unknown,
	): value is $shm_hitalama_map_history_text_file {
		return Boolean(
			value
				&& typeof value === 'object'
				&& typeof ( value as $shm_hitalama_map_history_text_file ).hitalama_text_file === 'string',
		)
	}

	export type $shm_hitalama_map_history_data = {
		id: string
		title: string
		source: $shm_hitalama_map_history_source
		changes: readonly $shm_hitalama_map_history_change[]
		origin?: string
	}

}
